import { render, staticRenderFns } from "./PromocoesSemelhantes.vue?vue&type=template&id=a260a27a"
import script from "./PromocoesSemelhantes.vue?vue&type=script&lang=js"
export * from "./PromocoesSemelhantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports